module.exports = __webpack_public_path__ + "img/solarroof_mob.2c9e5de.jpg";